var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('router-view'),_c('TabBar'),(_vm.pendingCount > 0 && !_vm.isApprovalPage && !_vm.isOverviewPage)?_c('div',{staticClass:"floating-icon",on:{"click":_vm.goToApprovalPage}},[_c('van-icon',{attrs:{"name":"bell"}}),_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.pendingCount))])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }